var $ = require('jquery');
var NotificationBase = require('../NotificationBase');
/**
 * Created by mulmeanu on 1/6/15.
 */
(function() {
    var BlogMobileAppNotification = NotificationBase.extend({
        softDeletion: true,
        /**
         * Default severity for GuidanceNotification
         */
        severityDefault: 4,
        /**
         * Default category for GuidanceNotification
         */
        categoryDefault: 2,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-star',
        /**
         * this method must be implemented by all Notifications
         */
        getContent: function() {
            return jimdoData.messages.notifications.blogmobileapp;
        },

        globalAction: function() {
            $.proxy(guidedAssistant._openHelpTopic, guidedAssistant)('apps_blog_mobile');
        },

        getName: function() {
            return 'BlogMobileAppNotification';
        }
    });

    module.exports = BlogMobileAppNotification;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/Notifications/BlogMobileAppNotification.js
 ** module id = 658
 ** module chunks = 0
 **/